import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";

export const registerBlockSDate = async (blockSDateId) => {

  try {
    const { data } = await _axios.patch(`/api/blockSDates/${blockSDateId}`, { status: "registered" });
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateSuppliesByRB = async (comsumptions) => {
  try {
    const { data } = await _axios.patch('/api/decrementSupsQuantity', { objects: comsumptions });
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}